<script>
import BreadcrumbHowItWorks from "../howItWorks/breadcrumbHowItWorks.vue";
import HowItWorksContent from "../howItWorks/howItWorksContent.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import FooterSection from "../package/footerSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";

export default {
  name: "privacyPolicyContent",
  components: {
    HeaderSection,
    DrawerAside,
    FooterSection,
    propertyIconSet,
    // MobileAppDownload,
    HowItWorksContent,
    BreadcrumbHowItWorks
  }
}
</script>

<template>
  <el-row
    style="padding: 30px 15px 30px 15px; background-color: #fff; margin: 0"
  >
    <el-col :span="24">
      <el-row>
        <el-col :span="24">
          <span class="privacy-unifi-title">Privacy Policy</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 16px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400"
          >This policy describes how UNIFI AUSTRALIA Pty Ltd (ACN 669 133 377) (UNIFI, we, -us or our) collects, manages, stores, uses and discloses your personal information.  </span>
          <br />
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >It contains the broad privacy framework within which we operate, and should be read in conjunction with any:  ;
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; supplementary privacy policies;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; and implementation procedures, that we introduce or vary from time to time.</span
            >
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >If you do not agree with the terms of this policy, please do not provide us with your personal information.
          </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">DEFINITIONS </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >To explain some of the terminology which commonly appears in this policy:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-italic">Information and Records</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Information and records may be in electronic or hard copy form. This policy does not extend to information or records that are publicly available,
            or that would constitute an “employee record” as defined by the Privacy Act 1988 (Cth) (Privacy Act).  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-italic">Sensitive information</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Sensitive information is an important type of personal information relating to your: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; biometrics;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; criminal record;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; genetics;</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; health;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; membership of a political association;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; membership of a professional or trade association; </span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; membership of a trade union;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; philosophical beliefs;</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; political opinions;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; racial or ethnic origin;</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; religious beliefs or affiliations;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022;  or sexual orientation or practices.</span
            >
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">HOW DOES UNIFI COLLECT AND HOLD PERSONAL INFORMATION? </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We collect personal information in a number of ways, including:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; directly from you,</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; via email,</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; telephone,</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; post,</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; when you provide details for our mailing lists,</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; purchase our services,</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; place a reservation for available properties,</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; participate in our promotions,</span
            >
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; create a referral account for our website or when you join one of our clubs or programs;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; and from third parties to whom you make payments in connection with our reservations or services,
              or to whom you provide personal details in connection with the receipt of marketing materials. This includes third parties who you authorise to provide us with personal information.  </span
            >
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-italic">Cookies</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Our website uses ‘cookies’ to improve your browser experience.
            Cookies are small text files that are downloaded and stored onto your computer’s browser directory when you visit a particular website.
            By using our website, you consent to our use of cookies.  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Cookies are used to track the pages and services you visit on our website and to ensure that you are able to
            move freely across our website without the need to re-enter information that you have already provided. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We use cookies to collect information including: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your computer’s IP address and other technical information;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; the date and time at which you access our website and the duration of your visit; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span
            >&#x2022; and the type of browser you are using.</span
            >
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >It is possible to disable cookies by adjusting your Internet browser’s setting, such that it refuses cookies. However,
            our website may not function correctly in the event that your browser refuses cookies.
            For an optimal browsing experience, we recommend that you allow the use of cookies.  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-italic">Personal information</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will only solicit and collect personal information if:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; it is reasonably necessary in order for us to provide our services and conduct our functions and activities;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; or we are permitted to do so by law. </span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-italic">Sensitive information</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will only solicit and collect sensitive information if:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; we have your consent, and it is reasonably necessary for us to collect sensitive information to enable us to carry out relevant functions or activities; or  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; we are permitted to do so by law.</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">WHAT TYPES OF PERSONAL INFORMATION DOES UNIFI COLLECT AND HOLD? </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Depending upon how you interact with us, we may collect the following types of personal information from you:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your name, gender and date of birth;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your email address;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your occupation, job title and place of business;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; the technology you use to access our services;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your residential and postal address;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; telephone numbers;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; your company name and Australian Business Number;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; or your superannuation fund details. </span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >You may refuse to provide personal information to us. However, if you exercise this right of refusal,
            it may affect our ability to meet our obligations to you or to a third-party agency.  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >You may also deal with us anonymously or by using a pseudonym. However,
            if you do so, we may be prevented from providing you with accurate or useful information,
            and you may not be able to access our full range of services.   </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">WHY DOES UNIFI COLLECT, HOLD, USE AND DISCLOSE PERSONAL INFORMATION?</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We may collect, hold and use your personal information for a number of reasons including: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to provide information in relation to our services and available properties marketed for sale by our related companies and business associates,
              including those we consider may be of interest to you in the future;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;  to administer and manage processes which are key to our operations, such as processing reservations of available properties or orders for our services;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to effect the collection of money that you owe to us and to support auditing, compliance and other corporate governance functions;
              to assess any application for employment during the recruitment process; to assess your creditworthiness;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to create an online referral account for you to access our website; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to determine your eligibility for certain types of goods or services that may be of interest to you; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to answer your queries, provide you with information you may have requested and generally conduct dealings with you; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; and to comply with legislative or other legal requirements. </span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We may disclose your personal information for a number of reasons including:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to identify you and verify your age, identity and corporate information; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;   to provide our services to you, or the organisation that you represent;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to improve our website and the services that we provide; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; to communicate with you; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; and for other purposes which are related, or directly related (in the case of sensitive information), to the purpose for which your information was initially collected.</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We may disclose your personal information to:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; our related parties;   </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;   to provide our services to you, or the organisation that you represent;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; other companies or individuals that assist us to provide our reservations and other services, </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; other companies or individuals that assist us to provide our reservations and other services,</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >This includes: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; electronic transactions / payment service providers, to process reservations and other orders for our services;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;   online booking service providers, to process bookings for our services;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;  government authorities or other agencies where the disclosure is required or authorised by law; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; anyone else to whom you authorise us to disclose your personal information;  </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; prospective purchasers of all or some of our business or assets, in the event of a merger, reorganisation or sale of our business or assets; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; information technology / cloud service providers, such as persons who develop any of the software used by our business;   </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; and external business advisors, such as auditors and lawyers.</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >There are also a limited number of circumstances in which the Privacy Act permits us to use or disclose your personal information, without your consent.
            An example of this is where the use or disclosure is necessary to prevent a serious and imminent threat to any person's life,
            health or safety or a serious threat to public health or safety.  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">USE OF THIRD-PARTY SOFTWARE</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >As at 4/11/2024, our website uses the following services and technologies that are supplied by third
parties:  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; Stripe</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;  Mailchimp</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; Google Analytics</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; Meta</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; AWS</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Your personal information may be collected directly by the third-party providers of the abovementioned
services and technologies, when you input personal information via our website. You should review the
privacy policies of third parties who provide those technologies, to ensure that you are satisfied with the
manner in which they collect, manage, store, use and disclose your personal information. Except where
we state otherwise in this policy, those third parties’ dealings in your personal information are not
subject to our control and we are not sponsored, affiliated or associated with those providers.  </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">DIRECT MARKETING</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We may collect, store and use your personal information to market our services to you, where you have
provided your implied or express consent for us to do so. Consent may be implied when you have placed
a reservation or purchased services from us, joined one of our clubs or programs, entered into a
promotion conducted by us, where you have subscribed to receive information from us or where you
have enquired about services that we provide. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >You may always opt out of receiving marketing material by contacting our Privacy Officer or using the
method that is provided in any of our electronic marketing communications to you. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will not disclose your personal information to a third party for them to market their products or
services to you, without your consent. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">CROSS-BORDER DISCLOSURE OF PERSONAL INFORMATION</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Personal information submitted on this website will be stored on the Cloud (that is, the internet). To
assist UNIFI to store and access your personal information on the Cloud, UNIFI may store your personal
information with, or allow it to be accessed by, overseas third parties who provide:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">

            <li class="privacy-unifi-para font-w700">
              <span>1. Software and maintenance services for the Cloud;</span>
            </li>
            <li class="privacy-unifi-para font-w700">
              <span>2. Training services in connection with using and accessing the Cloud; and</span>
            </li>
            <li class="privacy-unifi-para font-w700">
              <span>3. Infrastructure / hardware used to access the Cloud. </span>
            </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >As those third parties are situated, and store content, offshore (including in jurisdictions such as
Belgium, Chile, Denmark, Finland, Ireland, Netherlands, Singapore, Taiwan and the United States of
America), your personal information may be transmitted, disclosed, stored or accessed to and from
overseas jurisdictions. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >If you submit your personal information on this website, you are consenting to the transmission,
disclosure, storage and access of your personal information by third parties in overseas jurisdictions. In
that respect, APP 8 which ordinarily obliges UNIFI to take reasonable steps to ensure that overseas
recipients of your personal information do not breach the APPs (exceptAPP1) will not apply. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >Please note that if any of those overseas recipients handle your personal information in a manner which
is inconsistent, or does not comply, with the APPs: </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>1. to the maximum extent permitted by law, UNIFI will not be accountable under the Privacy Act for
any resulting loss or damage that you may suffer;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>2. to the maximum extent permitted by law, you will not be able to seek redress against UNIFI
under the Privacy Act; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>3. the overseas recipient may not be subject to any privacy obligations at all, or to any principles
similar to the APPs; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>4. you may not be able to seek redress against the overseas recipient in their jurisdiction; and </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>5. in holding your personal information, the overseas recipient may be subject to foreign laws which
compel their disclosure of your personal information to other parties, such as overseas
government authorities.  </span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">HOW DOES UNIFI HOLD AND SECURE YOUR PERSONAL INFORMATION?</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will take all reasonable steps to ensure the personal information we collect, use, or disclose is
accurate, up to date, complete and relevant, having regard to the purpose of the collection, use or
disclosure. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >You should ensure that any personal information you provide to us is both relevant and accurate. We
have in place user names, passwords and access restrictions that provide electronic protection of
personal information stored electronically. There are inherent risks with the transmission of data over
the internet. Whilst reasonably appropriate security measures are in place for the protection of your
personal information, you must be aware that no guarantee is made that your personal information is
completely secure. We also secure hard copy personal information within buildings or other storage
facilities, by placing restrictions on access to those buildings or facilities (for example, by locking the
buildings and filing cabinets in which the personal information is stored).</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >In the event of any unauthorised access and/or disclosure of your personal information, we comply with
our obligations under the Privacy Act in dealing with any such unauthorised access and/or disclosure,
including any obligations which may arise in respect of eligible data breaches within the meaning of the
Privacy Act. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">HOW CAN YOU ACCCESS AND SEEK CORRECTION OF YOUR PERSONAL INFORMATION?</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will deal with your requests for access or correction of your personal information, in accordance with
this policy. All requests must be made in writing, and in the appropriate form specified by us from time to
time. Within a reasonable timeframe after receiving your application, we will take reasonable steps to
inform you of what personal information we hold. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We will ordinarily grant access to the personal information unless:</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; margin-left: 10px;">
        <el-col :span="24">
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; giving access would have an unreasonable impact on the privacy of other individuals;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022;  the request for access is frivolous or vexatious;</span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; we are entitled to reject your access to the personal information pursuant to any law; </span>
          </li>
          <li class="privacy-unifi-para font-w700">
            <span>&#x2022; or the access would be unlawful.</span>
          </li>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We reserve the right to charge a reasonable fee for providing access to the personal information, but not
for making the application or correcting personal information held by us. We may withhold access to the
personal information until the fee is paid. If you are of the view that your personal information requires
correction, you should contact the Privacy Officer listed below. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">COMPLAINTS</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >If you believe that we have breached this policy, please contact our Privacy Officer by email at
team@unifiproperty.com or by mail to: Privacy Officer, 55 George Street, Norwood, South Australia 5067. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >We take all complaints seriously and will respond to you within a reasonable period of time, unless we
consider your complaint to be frivolous, vexatious or without legal or factual merit. If you are not satisfied
with the way in which we have handled your complaint, you can make a complaint to the Australian
Information Commissioner. </span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-sub-title text-underline">MORE INFORMATION</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <span class="privacy-unifi-para font-w400 mt-12"
          >If you have any questions or require further information please contact our Privacy Officer by e-mail at
team@unifiproperty.com.</span>
        </el-col>
      </el-row>


    </el-col>
  </el-row>
</template>

<style scoped>
.privacy-unifi-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.privacy-unifi-sub-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.text-underline {
  text-decoration: underline;
}
.text-italic {
  font-style: italic;
  font-weight: 400;
}
.privacy-unifi-para {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 125%;
}
.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #2d2d2d;
  color: #f5f5f5;
}
.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #2d2d2d;
}
.el-collapse-item /deep/ .el-collapse-item__content {
  color: #f5f5f5;
}
.font-w400 {
  font-weight: 400;
}
.font-w700 {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/privacyPolicy/privacyPolicyContent.vue